import { Typography, Table, TableBody } from '@mui/material';

import {
  HeaderStyled,
  StyledTableRow,
  StyledTableCell,
} from './PrivacyPolicyTablesStyled';

interface TableData {
  [key: string]: string;
}

interface TableProps {
  data: TableData | string;
}

export const PrivacyPolicyTables = ({ data }: TableProps) => {
  if (typeof data !== 'string') {
    const createTable = () => {
      const tableRows = Object.entries(data)
        .slice(1)
        .map(([key, value]) => {
          const cellStyling = key.startsWith('sub') ? 'body2' : 'body2';
          return (
            <StyledTableRow key={key}>
              <StyledTableCell>
                <Typography
                  variant={cellStyling}
                  dangerouslySetInnerHTML={{ __html: value }}
                />
              </StyledTableCell>
            </StyledTableRow>
          );
        });

      return (
        <Table size="small">
          <HeaderStyled>
            <StyledTableRow>
              <StyledTableCell align="center">
                <Typography
                  variant="body2"
                  dangerouslySetInnerHTML={{ __html: data.header }}
                />
              </StyledTableCell>
            </StyledTableRow>
          </HeaderStyled>
          <TableBody>{tableRows}</TableBody>
        </Table>
      );
    };

    return <div>{createTable()}</div>;
  } else {
    return (
      <Typography variant="body2" dangerouslySetInnerHTML={{ __html: data }} />
    );
  }
};
